import { useTranslation } from "react-i18next";
import UploadImages from "./upload-images";
import { PropertyReport } from "../../Models/PropertyReport";

const PropertySummary: React.FunctionComponent<{ errors: any, property: PropertyReport, OnChangeImage: any, OnChangeDesc: any }> = (props) => {

    const { t } = useTranslation();

    const UploadImagesHandler = (images: any) => {
        props.OnChangeImage(images[0].src)
    }

    const HandleChangeDesc = (event: any) => {
        props.OnChangeDesc(event.target.value)
    }

    const countWordsAndCharacters = (value: string) => {
        const charCount = (value ? value.length : 0);
        return charCount;
    }


    return (

        <div className="row mb-3">
            <div className="col-md-12 ">
                <div className="card border-16 padd-20">
                    <div className="d-flex justify-content-center">
                        <div className="title-18 hero-title">
                            <i className="fa-solid fa-circle-exclamation marg-right-10" style={{ color: '#eb4799' }}></i> Select an exterior photo or your preferred image, then write a short summary to highlight the property.
                        </div>
                    </div>
                    <div className="row padd-20">
                        <div className={`col-md-6 mb-3 `}>
                            <UploadImages
                                errors={props.errors.propertyDetailsImage}
                                OnUploadImages={UploadImagesHandler}
                                image={props.property.propertyDetails?.image ?? ""}
                                multipleImgs={false}
                                height={"height-400"}
                                label={"Photo"}
                                listImages={props.property.listingImages || []}
                            />
                        </div>
                        <div className="col-md-6  mb-3">
                            <div className={`border-14 h-100 padd-20 back-F1F5F9 ${props.errors.propertyDetailsDesc ? 'input-error' : ''}`}>
                                <h3 className="title-20 mb-3">{t("report.summary")}</h3>
                                <textarea
                                    className="para-14 bold-500 color-06 textarea back-trans border-trans line-height-25 textarea-report"
                                    dir="auto"
                                    rows={4}
                                    placeholder={t("report.typeYourPropertyDescription")}
                                    cols={40}
                                    value={props.property.propertyDetails?.description ?? ""}
                                    onChange={HandleChangeDesc}
                                    maxLength={1000}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === '\n') {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                <div className="character-counter">
                                    {countWordsAndCharacters(props.property.propertyDetails?.description ?? "")}/1000
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default PropertySummary;